import { defineInternalTask } from '../../../config/types';
import { internalTasks, reviewTeams } from '../../../config/constants';

import { baseBindState } from './lib/helpers';

export const oddNumberOfMarriedDrivers = defineInternalTask({
  taskName: internalTasks.OddNumberOfMarriedDrivers,
  config: {
    staffDisplayName: 'Married driver count is odd: verification needed',
    reviewTeam: reviewTeams.uwOps,
    policyTypes: ['A'],
    enabled: true,
    trigger: ({ policy, offer }) => {
      const drivers = (offer?.quote?.drivers || []).filter(Boolean);
      const marriedDrivers = drivers.filter((d) => d?.maritalStatus === 'M');
      if (marriedDrivers.length === 0 || marriedDrivers.length % 2 === 0) {
        return null;
      }
      return { data: {}, bindState: baseBindState(policy) };
    },
    description: () =>
      'The Auto policy was bound with an odd number of married drivers. Please ensure that all drivers have the correct marital status and that any relevant additional persons are included or added as Non-rated individuals on the auto policy.'
  }
});
